import * as types from 'model/actionTypes'
import { DictT, SlotT } from 'shared/types/model'

export function receiveSlots (slots: DictT<SlotT>) {
  return {
    type: types.RECEIVE_SLOTS,
    slots
  }
}
